<template>
  <!-- AVAL : logo de l'ORGANISATION (configurable via Parametres >
       Organisation, comme la page de login), pas le logo vendeur AVAL.
       Fond transparent si l'admin televerse un PNG transparent.
       Endpoint /organisation/logo : logo televerse, sinon fallback build. -->
  <img
    src="/organisation/logo"
    alt="Organisation"
    style="height:48px;width:auto;max-width:200px;object-fit:contain;display:block;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
